import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const useFavorites = () => {
    const { user, login } = useAuth();
    const qc = useQueryClient();

    const { data } = useQuery({
        queryKey: ["favorites"],
        enabled: !!user,
        queryFn: async () => (await api.get("/favorites")).data,
    });

    const ids = new Set(data?.product_ids || []);
    const isFav = (productId) => ids.has(productId);

    const toggle = async (product) => {
        if (!user) {
            toast.info("Entre com o Google para salvar favoritos.");
            login();
            return;
        }
        try {
            const { data } = await api.post("/favorites/toggle", { product_id: product.id });
            qc.setQueryData(["favorites"], data);
            toast.success(
                data.favorited ? `${product.name} salvo nos favoritos.` : `${product.name} removido dos favoritos.`,
            );
        } catch (e) {
            if (e.response?.status === 401) {
                toast.info("Sua sessão expirou — entre novamente.");
                login();
            } else {
                toast.error("Não foi possível atualizar os favoritos.");
            }
        }
    };

    return { ids, isFav, toggle, data };
};

export default useFavorites;
